import { Deserialize } from 'cerialize'
import { call, put, select, takeLeading } from 'typed-redux-saga'
import {
	DrsFakeResponsesReserveModel,
	drsFakeResponsesApi,
	drsFakeResponsesNS,
	drsFakeResponsesSelectors,
	drsFakeResponsesSlice,
} from 'Pages/admin'
import {
	errorHandler,
	NOTIFICATION_TYPE,
	notifyMessageCreator,
	loadersSlice,
	gridSlice,
} from 'Modules'
import { ResponseCatalog } from 'Models'
import { FormNames } from 'Constants/FormNames'

function* getAll(action: drsFakeResponsesNS.GetAll) {
	try {
		const { params, clear } = action.payload
		yield* put(gridSlice.actions.setLoading(true))
		if (clear) {
			yield* put(drsFakeResponsesSlice.actions.clearAll())
		}
		const res = yield* call(drsFakeResponsesApi.getAll, params)
		const items = new ResponseCatalog<DrsFakeResponsesReserveModel>(res)
		items.entries = items.entries.map(
			(item): DrsFakeResponsesReserveModel => Deserialize(item, DrsFakeResponsesReserveModel)
		)
		if (!clear) {
			const oldItems = yield* select(drsFakeResponsesSelectors.getAll)
			items.entries = [...oldItems.entries, ...items.entries]
		}
		yield* put(drsFakeResponsesSlice.actions.setAll(items))
		yield* put(drsFakeResponsesSlice.actions.setRequestParams(params))
	} catch (error) {
		yield* call(errorHandler, error)
		yield* call(notifyMessageCreator, 'fake_responses.dadata_suggest_by_id_party.error', {
			options: { type: NOTIFICATION_TYPE.ERROR },
		})
	} finally {
		yield* put(gridSlice.actions.setLoading(false))
	}
}

function* getOne(action: drsFakeResponsesNS.GetOne) {
	try {
		const res = yield* call(drsFakeResponsesApi.getOne, action.payload)
		const item = Deserialize(res, DrsFakeResponsesReserveModel)
		yield* put(drsFakeResponsesSlice.actions.setOne(item))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* createOne(action: drsFakeResponsesNS.CreateOne) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		yield* call(drsFakeResponsesApi.createOne, action.payload)
		const params = yield* select(drsFakeResponsesSelectors.getRequestParams)
		yield* put(drsFakeResponsesSlice.actions.getAll({ params, clear: true }))
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(notifyMessageCreator, 'fake_responses.reserve_account.success')
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(errorHandler, error, FormNames.FAKE_RESPONSES.DADATA_SUGGEST_BY_ID_PARTY)
		yield* call(notifyMessageCreator, 'fake_responses.reserve_account_create.error', {
			options: { type: NOTIFICATION_TYPE.ERROR },
		})
	}
}

function* updateOne(action: drsFakeResponsesNS.UpdateOne) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		yield* call(drsFakeResponsesApi.updateOne, action.payload)
		const params = yield* select(drsFakeResponsesSelectors.getRequestParams)
		yield* put(drsFakeResponsesSlice.actions.getAll({ params, clear: true }))
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(notifyMessageCreator, 'fake_responses.reserve_account_update.success')
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(errorHandler, error, FormNames.FAKE_RESPONSES.DADATA_SUGGEST_BY_ID_PARTY)
		yield* call(notifyMessageCreator, 'fake_responses.reserve_account_update.error', {
			options: { type: NOTIFICATION_TYPE.ERROR },
		})
	}
}

function* deleteOne(action: drsFakeResponsesNS.DeleteOne) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		yield* call(drsFakeResponsesApi.deleteOne, action.payload)
		const params = yield* select(drsFakeResponsesSelectors.getRequestParams)
		yield* put(drsFakeResponsesSlice.actions.getAll({ params, clear: true }))
		yield* put(loadersSlice.actions.hideGlobalLoader())
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(errorHandler, error)
		yield* call(notifyMessageCreator, 'fake_responses.reserve_account_delete.error', {
			options: { type: NOTIFICATION_TYPE.ERROR },
		})
	}
}

export function* drsFakeResponsesSaga() {
	yield* takeLeading(drsFakeResponsesSlice.actions.getAll.type, getAll)
	yield* takeLeading(drsFakeResponsesSlice.actions.getOne.type, getOne)
	yield* takeLeading(drsFakeResponsesSlice.actions.createOne.type, createOne)
	yield* takeLeading(drsFakeResponsesSlice.actions.updateOne.type, updateOne)
	yield* takeLeading(drsFakeResponsesSlice.actions.deleteOne.type, deleteOne)
}
